/*
 * @Date: 2021-04-09 10:53:44
 * @author: yanhoup
 * @description: 登录时使用网关地址
 */
import { APP_MODE } from 'ice';
const protocolStr = process.env.NODE_ENV === 'development' ? 'https:' : document.location.protocol;
const GATEWAY_URLS = {
  dev: `${protocolStr}//giws-gateway-test.i4px.com`,
  test: `${protocolStr}//giws-gateway-test.i4px.com`,
  stage: `${protocolStr}//giws-gateway-stage.i4px.com`,
  prod: `${protocolStr}//giws-gateway.i4px.com`,
  us: `${protocolStr}//giws-gateway.us.i4px.com`,
  eu: `${protocolStr}//giws-gateway.eu.i4px.com`,
  asia: `${protocolStr}//giws-gateway.asia.i4px.com`,
  au: `${protocolStr}//giws-gateway.au.i4px.com`,
  wt: 'https://giws-gateway.gfn.cainiao.com',
  wtdaily: 'https://giws-gateway-test.gfn.cainiao.com',
};

/**
 * @description 网关请求地址
 */
const GATEWAY_URL = GATEWAY_URLS[APP_MODE];

export { GATEWAY_URL };
